
import base64ToArrayBuffer from "./base64ToArrayBuffer";
import ExpoRichiesteService from "services/API/ExpoRichieste/ExpoRichiesteService";

async function vedi_anteprima_contratto(idRichiesta) {
  console.log("download_pdf :" + idRichiesta);
  if (idRichiesta != 0) {
      let filename = 'ContrattoAgriumbria.pdf';

      ExpoRichiesteService.genera_pdf_contratto(idRichiesta)
          .then(response => {
            
              return response.data;
          })
          .then(blob => {

              var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
              var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
              var url = URL.createObjectURL(blobb);
              var a = document.createElement('a');
              a.href = url;
              a.target = "_blank";
              a.download = filename;
              document.body.appendChild(a); // append the element to the dom
              a.click();
              a.remove(); // afterwards, remove the element  
          })
          .catch(error => {
              console.error(error);
          });


  }
}
export default vedi_anteprima_contratto;